import { loadTenantCSS as loadDesignSystemTenantCSS } from "@albertine/design-system/loadTenantCSS";
import type { Tenant } from "albertine-shared-web";

const sharedWebTenantCSSLoaders: Record<Tenant, () => Promise<unknown>> = {
    albertine: () => import("@albertine/design-system/variables.albertine.css"),
    carlo: () => import("@albertine/design-system/variables.carlo.css"),
    hugoboss: () => import("@albertine/design-system/variables.hugoboss.css"),
    mastercard: () => import("@albertine/design-system/variables.mastercard.css"),
    "visa-i2": () => import("@albertine/design-system/variables.visa-i2.css"),
    revolut: () => import("@albertine/design-system/variables.revolut.css"),
};

export async function loadTenantCSS(tenant: Tenant) {
    await loadDesignSystemTenantCSS(tenant);
    await sharedWebTenantCSSLoaders[tenant]();
}
